import { memo, type ReactNode } from 'react'

import type { DataTableViewCommonProps } from './data-table.interface'
import { DataTableView } from './data-table-view.molecule'
import { buildDataTableViewProps } from './useDataTableViewProps.hook'

const DataTableLoadedInner = <TData,>(p: DataTableViewCommonProps<TData>): ReactNode => {
  const viewProps = buildDataTableViewProps(p)
  return <DataTableView {...viewProps} />
}

export const DataTableLoaded = memo(DataTableLoadedInner) as typeof DataTableLoadedInner
